import type { VehicleType } from '../../types/ui/Logistics';

export const VEHICLE_TYPES: VehicleType[] = ['sedan', 'suv', 'bus', 'van', 'limo', 'minibus', 'other'];
export const VEHICLE_TYPE_LABELS: Record<VehicleType, string> = {
  sedan: 'Sedan', suv: 'SUV', bus: 'Bus', van: 'Van',
  limo: 'Limousine', minibus: 'Minibus', other: 'Other',
};

export const GUIDELINE_TEAM_OPTIONS = [
  'Aunties', 'Branding', 'Couple', 'Decorator', 'Digital', 'Entertainment',
  'Extra Curricular', 'Food + Drinks', "Groom's Party", 'Initiators',
  'Internal Logistics', 'Inventory', 'Media', 'Planner', 'Security',
];
